var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe01Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_40196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 8.5249C0.902838 11.8109 3.30188 14.5039 6.4409 15.1811C5.23881 14.0367 4.41995 11.5643 4.33596 8.5249H0.666626Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 7.47502H4.33596C4.41995 4.4356 5.23885 1.96329 6.4409 0.818848C3.30171 1.496 0.902804 4.18884 0.666626 7.47502Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38574 8.5249C5.49598 12.2624 6.81356 14.8241 7.99983 14.8241C9.1861 14.8241 10.5037 12.2624 10.6139 8.5249H5.38574Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 1.17578C6.81348 1.17578 5.49594 3.73746 5.38574 7.47499H10.6141C10.5039 3.73746 9.1861 1.17578 7.99983 1.17578Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55908 15.1811C12.6983 14.5039 15.0972 11.8111 15.3334 8.5249H11.664C11.58 11.5643 10.7611 14.0366 9.55908 15.1811Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55908 0.818848C10.7612 1.9632 11.58 4.4356 11.664 7.47502H15.3334C15.0971 4.18901 12.6981 1.49597 9.55908 0.818848Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_40196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01Fill);
export default __webpack_public_path__ + "static/media/globe-01-fill.951f7f2d8d90a1839bc94e397b734378.svg";
export { ForwardRef as ReactComponent };